/**
 * Labstep
 *
 * @module components/ResourceTemplate/Action/Menu
 * @desc Action Menu for resourceTemplate
 */

import { EntityActionTransferOwnership } from 'labstep-web/components/Entity/Action/TransferOwnership';
import { ResourceTemplateActionDelete } from 'labstep-web/components/ResourceTemplate/Action/Delete';
import { ResourceTemplateActionDuplicate } from 'labstep-web/components/ResourceTemplate/Action/Duplicate';
import { ResourceTemplateActionShare } from 'labstep-web/components/ResourceTemplate/Action/Share';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { IResourceTemplateActionMenuProps } from './types';

export enum Action {
  view = 'view',
  share = 'share',
  duplicate = 'duplicate',
  delete = 'delete',
  export = 'export',
  revoke = 'revoke',
  transfer_ownership = 'transfer_ownership',
}

export const ResourceTemplateActionMenu: React.FC<
  IResourceTemplateActionMenuProps
> = ({ resourceTemplate, type, actions = [], options }) => (
  <ActionMenu type={type}>
    {actions.includes(Action.share) && (
      <ResourceTemplateActionShare
        resourceTemplate={resourceTemplate}
      />
    )}
    {actions.includes(Action.duplicate) && (
      <ResourceTemplateActionDuplicate
        resourceTemplate={resourceTemplate}
      />
    )}
    {actions.includes(Action.transfer_ownership) && (
      <EntityActionTransferOwnership entity={resourceTemplate} />
    )}
    {actions.includes(Action.delete) && (
      <ResourceTemplateActionDelete
        resourceTemplate={resourceTemplate}
        options={options}
      />
    )}
  </ActionMenu>
);

ResourceTemplateActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
